import VanillaTilt from 'vanilla-tilt';

$(function(){
    if ( $(window).width() >= 992 )
    {
        VanillaTilt.init(document.querySelectorAll('.js-tilt'), {
            glare: true,
            "max-glare": .08,
            reverse: false,
            max: 12
        });
    }
});